let _scrollTop
let isIOS = /iPhone|iPad/.test(navigator.userAgent)
class ModalHelper {
  // popup 顯示使用
  static afterOpen () {
    if(isIOS){
      document.body.style.position = 'fixed'
      _scrollTop = document.scrollingElement.scrollTop
      document.body.style.top = -_scrollTop + 'px'
    }else {
      document.body.style.position = 'relative'
      document.body.style.overflow = 'hidden'
    }
    
  }

  // popup 關閉使用
  static beforeClose () {
    if(isIOS){
      document.body.style.position = ''
      document.scrollingElement.scrollTop = _scrollTop
      document.body.style.top = ''
    }else {
      document.body.style.position = ''
      document.body.style.overflow = ''
    }
  }
}

export default ModalHelper


// WEBPACK FOOTER //
// ./src/utils/modalHelper.js